import Axios, { AxiosRequestConfig } from "axios";

export interface IRequestTopic {
  id: number;
  name: string;
}

export interface ICurrency {
  code: string;
  name: string;
}

export interface ITimezone {
  value: string;
  display_name: string;
}

export async function currencies(config?: AxiosRequestConfig) {
  const response = await Axios.get<ICurrency[]>("/api/currencies/", config);
  return response.data;
}

export async function getTimezones(config?: AxiosRequestConfig) {
  const response = await Axios.get<ITimezone[]>("/api/timezones/", config);

  return response.data.sort((a, b) => {
    // Convert "GMT-11:30" to "-11.30" and parse as a float for numerical sorting
    const offsetA = parseFloat(a.display_name.split(" ")[0].slice(3).replace(":", ".")) || 0;
    const offsetB = parseFloat(b.display_name.split(" ")[0].slice(3).replace(":", ".")) || 0;

    if (offsetA !== offsetB) return offsetA - offsetB;

    // Extract location name (everything after the first space) and sort alphabetically
    const nameA = a.display_name.substring(a.display_name.indexOf(" ") + 1).toLocaleLowerCase();
    const nameB = b.display_name.substring(b.display_name.indexOf(" ") + 1).toLocaleLowerCase();

    return nameA.localeCompare(nameB);
  });
}

export async function getGasStrategies(config?: AxiosRequestConfig) {
  const response = await Axios.get("/api/gas-strategies/", config);
  return response.data;
}

export async function getRequestTopics(config?: AxiosRequestConfig) {
  const response = await Axios.get("/api/contact/request-topics/", config);
  return response.data;
}

export interface IRequestTopic {
  id: number;
  name: string;
}
